// PasswordReset.js
// Form Input refs: https://stackoverflow.com/a/65885351

import React, { useRef, useState } from "react";
import { Image, Text, View } from "react-native";
import Button from "../../Partials/Buttons";
import TextInputRef from "../../Partials/TextInputRef";
import formRefs from "../../helpers/formrefs";
import logo from "../../assets/logo.png";
import { ScreenLoading } from "../../Partials/Status";
import { triggerAlert } from "../../Partials/AlertModal";

const PasswordReset = () => {
  const _theme = window.main.theme;
  const [passwordResetDataState, passwordResetDataSetState] = useState({});
  const [isScreenLoading, setIsScreenLoading] = useState(false);
  const [iHaveCodeState, iHaveCodeSetState] = useState(false);
  const [isSetPasswordState, isSetPasswordSetState] = useState(false);
  const [emailSentToState, emailSentToSetState] = useState("");
  const passwordResetFormRefs = useRef(new formRefs());

  const onSubmitEmail = async () => {
    const formData = passwordResetFormRefs.current.getAll();
    if (!("email" in formData) || !formData.email.trim()) {
      triggerAlert({
        show: true,
        title: "Email is required",
        message: "Please enter your email\nto reset your password.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = {};
      for (const field in formData) {
        postData[field] = formData[field];
      }
      const passwordreset_resp = await window.main.axios.post(window.main.api.passwordreset, postData);
      setIsScreenLoading(false);
      if (!!passwordreset_resp.data?.success) {
        passwordResetDataSetState(p=>({...p,...postData}));
        goToConfirmCode();
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (passwordreset_resp.data?.message || "Account email not found. Please check your email address and try again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred. Please try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const onSubmitConfirmation = async () => {
    const formData = passwordResetFormRefs.current.getAll();
    if ((!("email" in formData) || !formData.email.trim()) && !passwordResetDataState.email) {
      triggerAlert({
        show: true,
        title: "Email is required",
        message: "Please enter your email\nto reset youyr password.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    if (!("confirmcode" in formData) || !formData.confirmcode.trim()) {
      triggerAlert({
        show: true,
        title: "Confirmation Code is required",
        message: "Please enter the confirmation Code\nfrom your email.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = {
        email: (formData.email||passwordResetDataState.email),
        confirmcode: formData.confirmcode,
      };
      const confirmcode_resp = await window.main.axios.post(window.main.api.passwordresetconfirm, postData);
      setIsScreenLoading(false);
      if (!!confirmcode_resp.data?.success) {
        passwordResetDataSetState(p=>({...p,...postData}));
        isSetPasswordSetState(true);
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (confirmcode_resp.data?.message || "Verifying your confirmation code failed. Please check your information and submit again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred. Please try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const onSubmitComplete = async () => {
    const formData = passwordResetFormRefs.current.getAll();
    if (!passwordResetDataState.email) {
      iHaveCodeState(false);
      isSetPasswordSetState(false);
      return false;
    }
    if (!passwordResetDataState.confirmcode) {
      iHaveCodeState(false);
      isSetPasswordSetState(false);
      return false;
    }
    if (!("password" in formData) || !("confirmpw" in formData) || formData.password!==formData.password) {
      triggerAlert({
        show: true,
        title: "Passwords to not match",
        message: "Please check that your password\nand confirmation password match.",
        onConfirmPressed: async () => {
          triggerAlert();
        },
      });
      return false;
    }
    // Submit
    try {
      setIsScreenLoading(true);
      const postData = {
        email: passwordResetDataState.email,
        confirmcode: passwordResetDataState.confirmcode,
        password: formData.password,
      };
      const completereg_resp = await window.main.axios.post(window.main.api.passwordresetcomplete, postData);
      setIsScreenLoading(false);
      if (!!completereg_resp.data?.success) {
          triggerAlert({
            show: true,
            title: "Password Is Reset!",
            message: "Your account password is reset.\n\nYou will be redirected to the\nlogin screen to access your account.",
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              window.main.lib.setCurrentView("login");
              triggerAlert();
            },
          });
        return;
      } else {
        return window.setTimeout(() => {
          triggerAlert({
            show: true,
            title: "Oops!",
            message: (completereg_resp.data?.message || "Completing your account registration failed. Please check your information and submit again."),
            showConfirmButton: true,
            confirmText: "Ok",
            onConfirmPressed: () => {
              triggerAlert();
            },
          });
        },1);
      }
    } catch (err) {
      console.log("API response error:", err);
      // Non-200 response...
      setIsScreenLoading(false);
      let errMsg = window.main.lib.parseErrorMessage(err);
      if (!errMsg || typeof(errMsg)!=="string") {
        errMsg = "An error occurred. Please try again."
      }
      triggerAlert({
        show: true,
        title: "Oops!",
        message: errMsg,
        showConfirmButton: true,
        confirmText: "Ok",
        onConfirmPressed: () => {
          triggerAlert();
        },
      });
    }
  };

  const goToConfirmCode = async () => {
    const formData = passwordResetFormRefs.current.getAll();
    if (!!("email" in formData) && !!formData.email.trim()) {
      emailSentToSetState(formData.email);
    }
    iHaveCodeSetState(true);
  };

  const backToPasswordReset = async () => {
    iHaveCodeSetState(false);
  };

  const backToLogin = async () => {
    window.main.lib.setCurrentView("login");
  };

  const onKeyPressEnterSubmit = (e) => {
    if(e.key==="Enter") {
      if (!!iHaveCodeState && !!isSetPasswordState) {
        onSubmitComplete();
      } else if (!!iHaveCodeState && !isSetPasswordState) {
        onSubmitConfirmation();
      } else {
        onSubmitEmail();
      }
    }
  };

  const styles = window.main.theme.externalUserPagesStyles;
  const _email_ref = useRef();
  const _confirmcode_ref = useRef();
  const _password_ref = useRef();
  const _confirmpw_ref = useRef();
  const [isPasswordHiddenState, isPasswordHiddenSetState] = useState(true);
  const [isConfirmPwHiddenState, isConfirmPwHiddenSetState] = useState(true);
  const toggleIsPasswordHidden = ()=>{
    isPasswordHiddenSetState(s=>(!s));
  };
  const toggleIsConfirmPwHidden = ()=>{
    isConfirmPwHiddenSetState(s=>(!s));
  };
  // Password Reset Form
  return (
    <View style={{...styles.container,position:"static"}}>
      <View style={{...styles.wrapper,flexDirection:"column",alignItems:"center",position:"static"}}>
        <View style={styles.headerRow}>
          <Image nativeID={"brand_logo"} style={styles.headerLogo} source={logo} resizeMode={"cover"} accessibilityLabel={"VetManaged Logo"} />
          <Text nativeID={"app_title"} style={ styles.headerTitle }> VetManaged</Text>
        </View>
        <View style={styles.headerRow}>
          <Text style={styles.headerTitle}>Pet Parent Registration</Text>
        </View>
        {!iHaveCodeState && !isSetPasswordState &&
          <>
            <View style={{width:250,alignSelf:"center"}}>
              <Text style={{..._theme.fieldLabelInline}}>Email: *</Text>
              <TextInputRef key="passwordreset_email" ref={_email_ref} nativeID="input_email" textContentType="email" autoComplete="email" formrefs={passwordResetFormRefs.current} datakey={"email"} placeholder="Email Address..." style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} />
            </View>
            <View style={styles.headerRow}>
              <Text style={{textAlign:"center"}}>You will be emailed a confirmation code to complete your password reset.</Text>
            </View>
            <Button nativeID="button_passwordreset" type="primary" ficon="user-plus" text="Send Email" onpress={onSubmitEmail} style={{width:250,marginTop:0}} />
            <Button nativeID="button_ihavecode" type="link" ficon="check-square" text="I have a Code" onpress={goToConfirmCode} style={{width:250,marginTop:20}} />
            <Button nativeID="button_backtologin" type="link" ficon="arrow-left" text="Back to Login" onpress={backToLogin} style={{width:250,marginTop:10}} />
          </>
        }
        {!!iHaveCodeState && !isSetPasswordState &&
          <>
            <View style={{width:250,alignSelf:"center"}}>
              {!emailSentToState &&
                <>
                  <Text style={{..._theme.fieldLabelInline}}>Email:</Text>
                  <TextInputRef key="register_email" ref={_email_ref} nativeID="input_email" textContentType="email" autoComplete="email" formrefs={passwordResetFormRefs.current} datakey={"email"} placeholder="Email Address" style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} />
                </>
              }
              {!!emailSentToState &&
                <>
                  <Text style={{textAlign:"center"}}>An email was sent to{"\n"}<Text style={{fontWeight:"600",lineHeight:30}}>{emailSentToState}</Text>{"\n"}containing a confirmation code.{"\n\n"}</Text>
                  <Text style={{textAlign:"center"}}>Please enter the{"\n"}confirmation code below.{"\n"}{"\n"}</Text>
                </>
              }
              <Text style={{..._theme.fieldLabelInline}}>Confirmation Code:</Text>
              <TextInputRef key="register_confirmcode" ref={_confirmcode_ref} nativeID="input_confirmcode" textContentType="confirmcode" autoComplete="confirmcode" formrefs={passwordResetFormRefs.current} datakey={"confirmcode"} placeholder="Confirmation Code" style={{...window.main.theme.textInputLarge,marginBottom:12}} onKeyPress={onKeyPressEnterSubmit} autoFocus={true} />
            </View>
            <Button nativeID="button_submitcode" type="primary" ficon="check-square" text="Confirm" onpress={onSubmitConfirmation} style={{width:250,marginTop:20}} />
            <Button nativeID="button_backtoregister" type="link" ficon="arrow-left" text="Back to Register" onpress={backToPasswordReset} style={{width:250,marginTop:10}} />
          </>
        }
        {!!iHaveCodeState && !!isSetPasswordState &&
          <>
            <View style={{width:250,alignSelf:"center"}}>
              <Text style={{..._theme.fieldLabelInline}}>Password:</Text>
              <View style={{position:"relative"}}>
                <TextInputRef key="_password_ref" ref={_password_ref} nativeID="input_password" textContentType="password" autoComplete="password" formrefs={passwordResetFormRefs.current} datakey={"password"} placeholder="Password" style={{...window.main.theme.  textInputLarge,marginBottom:12,paddingRight:30}} secureTextEntry={isPasswordHiddenState} onKeyPress={onKeyPressEnterSubmit} />
                <Button nativeID="button_toggle_passwordhidden" type="link" ficon={!!isPasswordHiddenState?"eye-off":"eye"} text="" onpress={toggleIsPasswordHidden} style={{position:"absolute",top:3,right:8,paddingHorizontal:0}} iconSize={15} />
              </View>
              <Text style={{..._theme.fieldLabelInline}}>Confirm Password:</Text>
              <View style={{position:"relative"}}>
                <TextInputRef key="_confirmpw_ref" ref={_confirmpw_ref} nativeID="input_confirmpw" textContentType="confirmpw" autoComplete="confirmpw" formrefs={passwordResetFormRefs.current} datakey={"confirmpw"} placeholder="Confirm Password" style={{...window.main.theme.textInputLarge,marginBottom:12,paddingRight:30}} secureTextEntry={isConfirmPwHiddenState} onKeyPress={onKeyPressEnterSubmit} />
                <Button nativeID="button_toggle_confirmpwhidden" type="link" ficon={!!isConfirmPwHiddenState?"eye-off":"eye"} text="" onpress={toggleIsConfirmPwHidden} style={{position:"absolute",top:3,right:8,paddingHorizontal:0}} iconSize={15} />
              </View>
            </View>
            <Button nativeID="button_submitpw" type="primary" ficon="check-square" text="Complete" onpress={onSubmitComplete} style={{width:250,marginTop:20}} />
          </>
        }
        <ScreenLoading loadingState={isScreenLoading} style={{paddingTop:100,opacity:0.7}} />
      </View>
    </View>
  );
};

export default PasswordReset;
